import React from 'react';
export const withShouldRenderProp = (WrappedComponent) => {
    const ComponentWithShouldRenderProp = (props) => {
        const { shouldRender, } = props;
        if (!shouldRender)
            return null;
        return (React.createElement(WrappedComponent, Object.assign({}, props)));
    };
    return ComponentWithShouldRenderProp;
};
//# sourceMappingURL=withShouldRenderProp.js.map